export default __webpack_public_path__ + "static/media/slide3.8c093cb1.jpg";